import { Extension } from '@tiptap/core';
import { Fragment, Slice } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { normalizeInvisibleCharacters } from 'src/utils/InvisibleCharactersUtils';

const normalizeFragment = (fragment) => {
  const nodes = [];
  fragment.forEach((node) => {
    if (node.isText) {
      const text = normalizeInvisibleCharacters(node.text);
      nodes.push(text === node.text ? node : node.withText(text));
    } else {
      nodes.push(node.copy(normalizeFragment(node.content)));
    }
  });
  return Fragment.fromArray(nodes);
};

/**
 * @param {Slice} slice
 * @returns {Slice}
 */
export const normalizePastedSlice = (slice) => new Slice(
  normalizeFragment(slice.content),
  slice.openStart,
  slice.openEnd,
);

const NormalizePastedText = Extension.create({
  name: 'normalizePastedText',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('normalizePastedText'),
        props: {
          transformPasted: normalizePastedSlice,
        },
      }),
    ];
  },
});

export default NormalizePastedText;
